import * as React from "react";
const SvgFiRrUfoBeam = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ufo-beam_svg__a)">
      <path
        fill="#062147"
        d="M17.95 5.227A6.01 6.01 0 0 0 12 0a6.01 6.01 0 0 0-5.95 5.227C2.192 6.014 0 7.492 0 9.333 0 12.396 6.037 14 12 14s12-1.604 12-4.667c0-1.841-2.192-3.319-6.05-4.106M12 2c2.206 0 4 1.794 4 4v.206c-.475.285-1.652.795-4 .795-2.365 0-3.542-.517-4-.79v-.21A4.005 4.005 0 0 1 12 2m0 10C5.796 12 2 10.273 2 9.333c0-.398 1.074-1.41 4.168-2.087q.032.049.07.094C6.474 7.617 7.859 9 12 9s5.526-1.383 5.762-1.66q.037-.045.07-.094C20.926 7.923 22 8.935 22 9.333 22 10.273 18.204 12 12 12m-5.081 4.394-3 7a.997.997 0 0 1-1.313.525 1 1 0 0 1-.525-1.312l3-7a.994.994 0 0 1 1.313-.525 1 1 0 0 1 .525 1.312m15 6.213a.999.999 0 1 1-1.838.787l-3-7a.999.999 0 1 1 1.838-.787z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ufo-beam_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUfoBeam;
